import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Check, FileText, ArrowLeft } from 'lucide-react';

export default function ConfirmationPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const solicitud = location.state?.solicitud;

  if (!solicitud) {
    navigate('/');
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Success Card */}
        <div className="bg-white rounded-lg shadow-lg border border-slate-200 p-8">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
              <Check className="w-10 h-10 text-green-600" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-heading font-bold text-center text-slate-900 mb-4">
            ¡Solicitud Enviada Exitosamente!
          </h1>

          {/* Message */}
          <p className="text-center text-slate-600 mb-8">
            Hemos recibido su solicitud de pruebas de laboratorio y se ha enviado un email de confirmación a <strong>{solicitud.vet_info.email}</strong>
          </p>

          {/* Details Card */}
          <div className="bg-slate-50 rounded-lg p-6 mb-8 border border-slate-200">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-amplicare flex items-center justify-center flex-shrink-0">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-heading font-semibold text-slate-900 mb-4">
                  Detalles de la Solicitud
                </h3>
                <dl className="space-y-2">
                  <div className="flex justify-between">
                    <dt className="text-slate-600 font-medium">ID de Solicitud:</dt>
                    <dd className="text-slate-900 font-mono text-sm bg-slate-100 px-2 py-0.5 rounded">
                      {solicitud.id_corto || `SOL-${solicitud.id.slice(0, 6).toUpperCase()}`}
                    </dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="text-slate-600 font-medium">Paciente:</dt>
                    <dd className="text-slate-900">{solicitud.patient_info.nombre}</dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="text-slate-600 font-medium">Especie:</dt>
                    <dd className="text-slate-900">{solicitud.patient_info.especie}</dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="text-slate-600 font-medium">Fecha:</dt>
                    <dd className="text-slate-900">{solicitud.fecha}</dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="text-slate-600 font-medium">Estado:</dt>
                    <dd>
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                        pendiente
                      </span>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
            <h4 className="font-semibold text-blue-900 mb-2">¿Qué sigue?</h4>
            <ul className="text-sm text-blue-800 space-y-1 list-disc list-inside">
              <li>Procesaremos su solicitud al recibir las muestras</li>
              <li>Recibirá los resultados en el tiempo establecido</li>
            </ul>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="flex-1 h-12"
              data-testid="new-request-button"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Nueva Solicitud
            </Button>
            <Button
              onClick={() => window.print()}
              className="flex-1 h-12 bg-primary-amplicare hover:bg-primary-amplicare-dark"
              data-testid="print-button"
            >
              Imprimir Confirmación
            </Button>
          </div>
        </div>

        {/* Logo */}
        <div className="flex justify-center mt-8">
          <img
            src="/amplicare-logo.svg"
            alt="Amplicare Lab"
            className="h-10 opacity-50"
          />
        </div>
      </div>
    </div>
  );
}